/**
 * Toggles 'inert' on all HTML elements that have
 * a particular class, plus all focusable elements
 * inside them, based on a boolean condition.
 *
 * @param {boolean} condition condition for inert
 * @param {selector} parentClass class on all parent elements to target
 */

import 'inert-polyfill';
import getAllFocusableElements from './mando-ui.getAllFocusableElements';

function inertElementsBehindOverlay(condition, parentClass) {
  if (!parentClass) {
    parentClass = '.js-overlay-inert';
  }

  const parentEls = document.querySelectorAll(parentClass);

  parentEls.forEach((parent) => {
    let els = getAllFocusableElements(parent);

    if (condition === true) {
      parent.setAttribute('inert', '');

      els.forEach((el) => {
        el.setAttribute('inert', '');
      });
    } else {
      parent.removeAttribute('inert');

      els.forEach((el) => {
        el.removeAttribute('inert');
      });
    }
  });
}

export default inertElementsBehindOverlay;
